type RandomSource = () => number;

export function pickRandomLoadingMessageIndex(
  currentIndex: number,
  messageCount: number,
  random: RandomSource = Math.random,
) {
  const normalizedCount = Math.max(0, Math.floor(messageCount));
  if (normalizedCount <= 1) return 0;

  if (currentIndex < 0 || currentIndex >= normalizedCount) {
    return Math.min(
      normalizedCount - 1,
      Math.floor(random() * normalizedCount),
    );
  }

  const candidate = Math.min(
    normalizedCount - 2,
    Math.floor(random() * (normalizedCount - 1)),
  );

  return candidate >= currentIndex ? candidate + 1 : candidate;
}
